import { useEffect, useRef } from 'react'
import ApexCharts from 'apexcharts'
import { getCSS } from '_metronic/assets/ts/_utils'
import { useThemeMode } from '_metronic/partials'

interface Props {
  options: ApexCharts.ApexOptions
  series: ApexCharts.ApexOptions['series']
  height?: string
}

const ProjectMachineBarChart: React.FC<Props> = ({ options, series, height = '420px' }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      chart?.destroy()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode, series])

  const refreshChart = () => {
    if (!chartRef.current) return

    const chartHeight = parseInt(getCSS(chartRef.current, 'height'))
    const chartWidth = parseInt(getCSS(chartRef.current, 'width'))

    const mergedOptions: ApexCharts.ApexOptions = {
      ...options,
      chart: {
        ...options.chart,
        height: chartHeight,
        width: chartWidth,
      },
      series,
    }

    const chart = new ApexCharts(chartRef.current, mergedOptions)
    chart.render()
    return chart
  }

  return <div ref={chartRef} style={{ height, width: '100%' }} />
}

export default ProjectMachineBarChart
